export default __webpack_public_path__ + "static/media/books-1440w.de009837.png";